module.exports = __webpack_public_path__ + "static/wonder-wheel-zoom-09a668fa8c2bdeac63827b19145d8a65.jpg";